import { useToast } from '@chakra-ui/react';
import BatchesParametersForm from '@Modules/admin/archiving/components/forms/batches/BatchesParametersForm';
import CustomReactSelect from '@Modules/core/components/form/CustomReactSelect';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { useMutation, useQuery } from '@tanstack/react-query';
import React from 'react';
import {
  getBatchesParametersDataTableColumns,
  TBatchesParametersDataTableData,
} from './BatchesParametersDataTableMeta';
import batchesParametersFormMeta from './BatchesParametersFormMeta';

const BatchesParametersMixedHandler = () => {
  const [rowDataTable, setRowDataTable] =
    React.useState<TBatchesParametersDataTableData>({
      primaryKey: '',
      tableName: '',
      batchStartTime: '',
      batchEndTime: '',
      purgedDays: '',
      purgedRecord: '',
      purgedSince: '',
      businessDate: '',
      status: '',
    });

  const editModalRef = React.useRef<any>(null);

  const formModalRef = React.useRef<{
    submitBtnRef: React.MutableRefObject<any>,
  }>(null);

  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ['Template'];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve([{}, {}, {}]), 500);
      });
    },
    refetchInterval: 120000,
    refetchIntervalInBackground: true,
    refetchOnMount: true,
    onSuccess: (data_: any) => {
      //
      console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const { mutateAsync, isLoading: isSubmitting } = useMutation({
    mutationFn: async (rowData: TBatchesParametersDataTableData) => {
      return await new Promise(function (resolve, reject) {
        setTimeout(() => resolve(rowData), 1000);
      });
    },
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    try {
      await mutateAsync(payload);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (row: any) => {
    setRowDataTable(row.original);

    editModalRef?.current?.onOpen();
  };

  const columns = getBatchesParametersDataTableColumns({
    isLoading,
    handleEdit,
  });

  const triggerSubmit = () => {
    // formModalRef?.current?.submitBtnRef?.current?.click();
  };

  return (
    <>
      
      <CC.Flex mb={10} justifyContent={'space-evenly'} direction={{ base: "column", md: "row" }} gap={10}>
        <CC.HStack spacing={4}>
          <CC.Text>Purge context id</CC.Text>
          <CC.Input type={'text'} defaultValue={'SETTLEMENT'} w={'auto'} />
        </CC.HStack>
        <CC.HStack spacing={4}>
          <CC.Text>Name</CC.Text>
          <CC.Input type={'text'} defaultValue={'SETTLEMENT'} w={'auto'} />
        </CC.HStack>
      </CC.Flex>

      <CC.Card>
        <CC.CardBody>
          <CustomReactTable data={data || []} columns={columns} />

          <CustomAppModal
            title="Editer"
            ref={editModalRef}
            actionBtn={
              <CustomSaveBtn
                isLoading={isLoading}
                isSubmitting={isSubmitting}
                onClick={() => {
                  triggerSubmit();
                }}
              />
            }
            actionBtnText={'Valider'}
            size="3xl"
            isCentered
            closeOnOverlayClick={false}
          >
            <BatchesParametersForm
              data={rowDataTable}
              meta={batchesParametersFormMeta}
              onSubmit={onSubmit}
              isLoading={isLoading}
              isSubmitting={isSubmitting}
              ref={formModalRef}
            />
          </CustomAppModal>
        </CC.CardBody>
      </CC.Card>
    </>
  );
};

export default BatchesParametersMixedHandler;
